export default __webpack_public_path__ + "static/media/iconTitleEvent.63252f65.png";